"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _get = _interopRequireDefault(require("lodash/get"));
var _DepositsStatusComponent = _interopRequireDefault(require("./DepositsStatusComponent"));
var _depositWithdrawalSelectors = require("../../../redux/selectors/depositWithdrawalSelectors");
var _instrumentPositionSelectors = require("../../../redux/selectors/instrumentPositionSelectors");
var _productsSelectors = require("../../../redux/selectors/productsSelectors");
var _depositActions = require("../../../redux/actions/depositActions");
var _modalActions = require("../../../redux/actions/modalActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, ownProps) {
  /**
   * @Todo - remove filtration
   */
  var depositTickets = (0, _depositWithdrawalSelectors.filteredDepositsByProductSelector)(state, ownProps.config);
  var instruments = (0, _instrumentPositionSelectors.instrumentSelectorInstruments)(state);
  var decimalPlaces = (0, _productsSelectors.decimalsByProductId)(state);
  var activeRequests = state.apexCore.orderHistory.activeRequests;
  var depositStartIndex = state.deposit.depositStartIndex;
  var fetching = activeRequests > 0;
  return {
    data: depositTickets,
    instruments: instruments,
    fetching: fetching,
    decimalPlaces: decimalPlaces,
    selectedAccountId: (0, _get["default"])(state, 'user.selectedAccountId'),
    depositStartIndex: depositStartIndex
  };
};

// DEV-8959: Add openTravelRuleModal action
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getDepositTickets: function getDepositTickets() {
      return dispatch((0, _depositActions.getDepositTickets)());
    },
    openTravelRuleModal: function openTravelRuleModal(deposit) {
      return dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.TRAVEL_RULE_DEPOSIT, {
        deposit: deposit
      }));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_DepositsStatusComponent["default"]);